import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from '../common/Footer';
import { baseUrl, examTypes } from "../../Utility/constants";
import { getSchoolId } from "../../Utility/commonFunctions";
import TeacherHeader from "../common/TeacherHeader";
import { ReportCardEndpoints } from "../../Utility/Endpoints";
import { Link } from "react-router-dom";
import useCurrentSession from '../../hooks/useCurrentSession';

import JSZip from "jszip";
import { saveAs } from "file-saver";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import ReactDOM from "react-dom/client";
import ReportCardTemplate from './report-card/ReportCardTemplate';

function ReportCard() {  
    const [students, setStudents] = useState([]); // ✅ store API response here

    const { currentSession } = useCurrentSession();
    
    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const teacherId = localStorage.getItem("userID");
            let response = await axios.get(
                `${ReportCardEndpoints.GetStudentDetailsForReportCard}?teacherId=${teacherId}`
            );
            if (response.data && response.data.length > 0) {
                setStudents(response.data); // ✅ Save data to state
            } else {
                setStudents([]);
                toast.info("No student records found");
            }
        } catch (error) {
            console.error("Error fetching schoolId", error);
        }
    };

    const downloadAllReportCards = async () => {

        try {

            const zip = new JSZip();

            const schoolId = await getSchoolId();

            const schoolResponse = await axios.get(
                `${baseUrl}/api/SchoolGeneralInfo/GetSchoolInfo?schoolId=${schoolId}`
            );
            const schoolData = schoolResponse.data;

            for (let i = 0; i < students.length; i++) {

                const stu = students[i];

                toast.info(`Generating ${i + 1} of ${students.length}`);
                
                const response = await axios.get(
                     `${baseUrl}/api/MarksFeeding/ReturnStudentDetailswithReportCardDetails?studentId=${stu.studentId}&sessionId=${currentSession?.sessionId}`
                );

                const studentData = response.data.studentDetails;
                const marksData = response.data.marksFeedings;

                const container = document.createElement("div");
                container.style.position = "absolute";
                container.style.left = "-9999px";
                container.style.top = "0";
                // container.style.width = "794px";
                container.style.width = "210mm";
                container.style.padding = "0";
                container.style.margin = "0";
                container.style.background = "white";

                document.body.appendChild(container);

                const root = ReactDOM.createRoot(container);

                root.render(
                    <ReportCardTemplate
                        studentData={studentData}
                        marksData={marksData}
                        schoolData={schoolData}
                    />
                );
                await new Promise(resolve => setTimeout(resolve, 1000));

                // const canvas = await html2canvas(container, {
                //     scale: 2,
                //     useCORS: true
                // });

                const canvas = await html2canvas(container, {
                    scale: 3,
                    useCORS: true,
                    letterRendering: true,
                    backgroundColor: "#ffffff"
                });

                const imgData = canvas.toDataURL("image/png");

                const pdf = new jsPDF({
                    orientation: "portrait",
                    unit: "mm",
                    format: "a4"
                });
                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

                // pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);

                pdf.addImage(
                    imgData,
                    'PNG',
                    0,
                    0,
                    210,
                    297
                );

                const pdfBlob = pdf.output('blob');

                const fileName =
                    `${studentData.examSeatNo}_${studentData.firstName}_${studentData.lastName}_ReportCard.pdf`;

                zip.file(fileName, pdfBlob);

                root.unmount();
                document.body.removeChild(container);
            }

            const content = await zip.generateAsync({ type: "blob" });

            saveAs(content, "All_Report_Cards.zip");

            toast.success("All Report Cards Downloaded Successfully");

        } catch (error) {

            console.log(error);
            toast.error("Failed To Download Report Cards");
        }
    }

    return (
        <>
            <TeacherHeader />
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="card-body">
                                    
                                        <div className="row">       
                                             <div className="col-md-10">
                                            <h3>Report Card Details</h3>        
                                            </div>                               
                                            <div className="col-md-2">
                                               <button
                                                    className="btn btn-success"
                                                    onClick={downloadAllReportCards}
                                                    disabled={students.length === 0}
                                                >
                                                    Download All
                                                </button>                                            
                                            </div>
                                        </div>                
                                    {/* Table */}
                                    <div className="row mt-4">
                                        {students.length > 0 && (
                                            <div className="col-md-12">
                                                <table className="table table-bordered table-striped">
                                                    <thead className="table-dark">
                                                        <tr>
                                                            <th>Exam Seat No</th>
                                                            {/* <th>Roll No</th>
                                                            <th>GR No</th> */}
                                                            <th>Student Name</th>
                                                            <th>Standard</th>
                                                            <th>Section</th>
                                                            <th>Stream</th>
                                                            <th>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {students.map((stu) => (
                                                            <tr key={stu.studentId}>
                                                                <td>{stu.examSeatNo}</td>
                                                                {/* <td>{stu.rollNo}</td>
                                                                <td>{stu.generalRegisterNo}</td> */}
                                                                <td>{stu.firstName} {stu.middleName} {stu.lastName}</td>
                                                                <td>{stu.standardName}</td>
                                                                <td>{stu.sectionName}</td>
                                                                <td>{stu.streamName}</td>
                                                                <td><Link className="btn btn-primary" target="_blank" to={`/report-card-print/${stu.studentId}/${currentSession?.sessionId}`}>Print Report Card</Link></td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-right" autoClose={3000} />
            <Footer />
        </>
    );
}

export default ReportCard;
